import styled, { useTheme } from 'styled-components';
import {
  BodyLarge,
  Heading1Text,
  TitleMedium,
} from '../../../../components/Texts';
import WidthContainer from '../../../../components/WidthContainer';
import { useEffect, useRef, useState } from 'react';
import { PHONE_MEDIA_QUERY } from '../../../../common/responsive';

const BackgroundColor = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.primary.primary};
  position: absolute;
  width: 100%;
  left: 0px;
`;

const Container = styled.div`
  min-height: 500px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 10px;
  height: fit-content;
  padding-bottom: 80px;
  padding-top: 80px;
`;

const CashbackImage = styled.img`
  margin-top: 40px;
  width: 100%;
  max-width: 600px;
  height: auto;
  object-fit: contain;
`;

const Cashback = () => {
  const backgroundRef = useRef(null);
  const [siblingHeight, setSiblingHeight] = useState(undefined);

  useEffect(() => {
    const updateHeight = () => {
      if (backgroundRef.current) {
        setSiblingHeight(backgroundRef.current.offsetHeight);
      }
    };

    updateHeight();

    const observer = new ResizeObserver(updateHeight);

    if (backgroundRef.current) {
      observer.observe(backgroundRef.current);
    }

    return () => observer.disconnect();
  }, []);

  const theme = useTheme();

  return (
    <>
      <BackgroundColor ref={backgroundRef}>
        <WidthContainer>
          <Container>
            <Heading1Text
              style={{ color: theme.background.primary, textAlign: 'center' }}
            >
              <span style={{ color: theme.special.purple }}>Earn cashback</span>{' '}
              on <br /> your gift card purchases
            </Heading1Text>
            <BodyLarge
              style={{
                color: theme.background.primary,
                maxWidth: 700,
                textAlign: 'center',
              }}
            >
              Cashback credited instantly to your wallet
            </BodyLarge>
            <CashbackImage src='/landing-v2/cashback.webp' />
          </Container>
        </WidthContainer>
      </BackgroundColor>
      <div style={{ height: siblingHeight }} />
    </>
  );
};

export default Cashback;
